module.exports = __webpack_public_path__ + "static/media/icon-shower.65ce1b27.svg";